import { Component, Input, Inject, SimpleChanges, OnChanges, ViewEncapsulation } from '@angular/core';
import { FunnelEntryAbstract } from '@app/core/interfaces';
import { LocalStorageService } from '@inshared/shared/util-storage';
@Component({
    selector: 'ins-funnel-entry',
    templateUrl: 'funnel-entry.component.html',
    styleUrls: ['funnel-entry.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FunnelEntryComponent implements OnChanges {
    @Input() size: string = null;
    @Input() payload: FunnelEntryAbstract = null;

    constructor(
        @Inject(LocalStorageService) private localStorage: Storage,
    ) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.payload && changes.payload.currentValue) {
            this.storeData(changes.payload.currentValue);
        }
    }

    private storeData(payload: FunnelEntryAbstract): void {
        this.localStorage.setItem('ls.data:opgeslagen', JSON.stringify(payload.data));
        this.localStorage.setItem('ls.last-state', JSON.stringify(payload.lastState));
    }
}
